import { __awaiter } from "tslib";
import { PublicClientApplication } from "@azure/msal-browser";
import Services from "../services";
import { assertNonNullish } from "@tedivo/tedivo-pure-helpers";
import { getTranslation } from "../i18/i18tn";
import { waitForCondition } from "@tedivo/tedivo-dom-helpers";
class EntraIdFederationProvider {
    constructor() {
        this.publicClientApp = undefined;
        // public loginWithRedirect = async () => {
        //   assertNonNullish(
        //     this.publicClientApp,
        //     getTranslation("errors:ENTRAID.publicClientApplicationNotInitialized"),
        //   );
        //   const handleResponse = (response: AuthenticationResult | null) => {
        //     console.log("handleResponse:", response);
        //     if (response !== null) {
        //       this.accountId = response.account.homeAccountId;
        //       // Display signed-in user content, call API, etc.
        //     } else {
        //       assertNonNullish(
        //         this.publicClientApp,
        //         getTranslation(
        //           "errors:ENTRAID.publicClientApplicationNotInitialized",
        //         ),
        //       );
        //       // In case multiple accounts exist, you can select
        //       const currentAccounts = this.publicClientApp.getAllAccounts();
        //       if (currentAccounts.length === 0) {
        //         const loginRequest: RedirectRequest = {
        //           scopes: ["openid"],
        //         };
        //         console.log("loginRequest:", JSON.stringify(loginRequest, null, 2));
        //         // no accounts signed-in, attempt to sign a user in
        //         this.publicClientApp.loginRedirect(loginRequest);
        //       } else if (currentAccounts.length > 1) {
        //         // Add choose account code here
        //       } else if (currentAccounts.length === 1) {
        //         this.accountId = currentAccounts[0].homeAccountId;
        //       }
        //     }
        //   };
        //   this.publicClientApp.handleRedirectPromise().then(handleResponse);
        // };
        this.loginWithPopup = (email) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g;
            assertNonNullish(this.publicClientApp, getTranslation("errors:ENTRAID.publicClientApplicationNotInitialized"));
            if (!email) {
                throw new Error("Email is required");
            }
            try {
                yield waitForCondition(() => this.isInitialized, 1000);
                // Request scopes
                const loginRequest = {
                    scopes: [process.env.NX_PUBLIC_ENTRAID_SCOPE || ""],
                    select_account: true,
                    loginHint: email,
                };
                // Msal loginPopup
                const loginResponse = yield this.publicClientApp.loginPopup(loginRequest);
                // Check if login was successful
                if (!loginResponse || !loginResponse.account) {
                    throw new Error("Login using Entra ID was not successful");
                }
                // Check if email is valid
                if (email.trim().toLowerCase() !==
                    ((_b = (_a = loginResponse.account) === null || _a === void 0 ? void 0 : _a.username) === null || _b === void 0 ? void 0 : _b.trim().toLowerCase())) {
                    throw new Error("Invalid email");
                }
                // Check if audience is valid
                // OIDC allows aud to be a string or string[]; MSAL may return either.
                // A strict !== against a string always fails for an array, rejecting valid tokens.
                const aud = (_d = (_c = loginResponse.account) === null || _c === void 0 ? void 0 : _c.idTokenClaims) === null || _d === void 0 ? void 0 : _d.aud;
                const clientId = (_e = this.publicClientApp) === null || _e === void 0 ? void 0 : _e.getConfiguration().auth.clientId;
                const audValid = Array.isArray(aud) ? aud.includes(clientId) : aud === clientId;
                if (!aud || !audValid) {
                    throw new Error("Invalid audience");
                }
                // Check if token is expired
                const secondsToExpire = (((_g = (_f = loginResponse.account) === null || _f === void 0 ? void 0 : _f.idTokenClaims) === null || _g === void 0 ? void 0 : _g.exp) || 0) - Date.now() / 1000;
                if (secondsToExpire < 0) {
                    throw new Error("Token expired");
                }
                // Check if there is an access token
                if (!loginResponse.accessToken) {
                    throw new Error("Access token is required");
                }
                // Pass token to API to verify it
                const res = yield Services.accounts.passEntraIdAccessToken(loginResponse.accessToken, email);
                return res.data;
            }
            catch (error) {
                let errorMessage = typeof error === "string" ? error : error.message;
                const stripPrefix = (s) => s.replace(/^\s*[A-Za-z0-9_]+:\s*/, "");
                errorMessage = stripPrefix(errorMessage);
                document.body.dispatchEvent(new CustomEvent("customError", {
                    detail: {
                        message: getTranslation("auth:logIn"),
                        translationKey: errorMessage || "errors:errorHasOcurred",
                        errorCode: "0",
                    },
                }));
            }
        });
        this.logout = () => {
            assertNonNullish(this.publicClientApp, getTranslation("errors:ENTRAID.publicClientApplicationNotInitialized"));
            this.publicClientApp.logoutRedirect();
        };
        const appId = process.env.NX_PUBLIC_ENTRAID_APPID;
        if (!appId) {
            console.error("EntraIdFederationProvider will not be initialized");
            return;
        }
        const config = {
            auth: {
                clientId: appId,
                redirectUri: `${window.location.origin}/oauth-response`,
                postLogoutRedirectUri: window.location.origin,
            },
        };
        // create PublicClientApplication instance
        this.publicClientApp = new PublicClientApplication(config);
        this.publicClientApp.initialize().then(() => {
            var _a;
            (_a = this.publicClientApp) === null || _a === void 0 ? void 0 : _a.clearCache().catch(console.error);
        });
    }
    // public getAccessTokenFromCode = async (code: string) => {
    //   assertNonNullish(
    //     this.publicClientApp,
    //     getTranslation("errors:ENTRAID.publicClientApplicationNotInitialized"),
    //   );
    //   const config = this.publicClientApp.getConfiguration();
    //   const appId = config.auth.clientId;
    //   if (!appId) {
    //     throw new Error("App ID is required");
    //   }
    //   const requestParamsStr = sessionStorage.getItem(
    //     `msal.${appId}.request.params`,
    //   );
    //   const requestCodeVerifier = sessionStorage.getItem(
    //     `msal.${appId}.code.verifier`,
    //   );
    //   assertNonNullish(requestParamsStr, "Request params are required");
    //   assertNonNullish(requestCodeVerifier, "Request code verifier is required");
    //   console.log(window.atob(requestParamsStr));
    //   const requestParams = JSON.parse(window.atob(requestParamsStr)) as {
    //     nonce: string;
    //     codeChallenge: string;
    //     state: string;
    //     correlationId: string;
    //   };
    //   // const base64url = (ab: ArrayBuffer) =>
    //   //   btoa(String.fromCharCode(...new Uint8Array(ab)))
    //   //     .replace(/\+/g, "-")
    //   //     .replace(/\//g, "_")
    //   //     .replace(/=+$/, "");
    //   // const d = await crypto.subtle.digest(
    //   //   "SHA-256",
    //   //   new TextEncoder().encode(requestCodeVerifier),
    //   // );
    //   const res = await Services.accounts.passEntraIdIdToken({
    //     code,
    //     nonce: requestParams.nonce,
    //     codeChallenge: requestParams.codeChallenge,
    //     codeVerifier: requestCodeVerifier,
    //     correlationId: requestParams.correlationId,
    //   });
    //   console.log("res:", JSON.stringify(res, null, 2));
    //   return res.data;
    // };
    get isInitialized() {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (_a = this.publicClientApp.controller.initialized) !== null && _a !== void 0 ? _a : false;
    }
}
const entraIdFederationProvider = new EntraIdFederationProvider();
export { entraIdFederationProvider };
